module.exports = "https://static.wmbcdn.com/uniweb/images/994400456429c1b6664738b2ba8c4b9b.html";